import React from 'react';
import ReactDOM from 'react-dom/client';
import {BrowserRouter} from 'react-router-dom';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
const routerBase = process.env.NODE_ENV === 'development' ? '/' : (process.env.PUBLIC_URL || '/');

root.render(
  <React.StrictMode>
    <BrowserRouter basename={routerBase}>
    <App />
    </BrowserRouter>
  </React.StrictMode>
);
